import React, { PropTypes, Component } from 'react';

import { NitroHeading, NitroDivider, NitroDefinition, NitroFormatter } from 'nitro-components';

import SummaryHeading from './SummaryHeading.js';

import styled from 'styled-components';

const SidepanelSection = styled.section`
  margin-bottom: 20px;
  border-bottom: 1px solid ${props=>props.footerDivider ? props.theme.color.border : 'none'};
`;



class SummaryTable extends Component {
  render() {
    // console.log('SummaryTable', this.props);

    const { category, rows, HeaderPostFix, ExtraSpacingRows, footerDivider, formatting } = this.props;

    const summary = rows.map((row, index) => ({
      title: row.Label,
      description: (formatting ? <NitroFormatter data={row.Value} type={row['@DataType']} /> : row.Value),
      type:row.type
    }));

    // switch to differnt headerlayout for last drill down
    // last drill down table data contains HeaderPostFix
    const header = !HeaderPostFix
      ? (<section>
          <NitroHeading label={category} labelHighlight={HeaderPostFix} size="1" align="center" noMargin />
          {category && <NitroDivider noTopPad sidePanel />}
        </section>)
      : (<section>
          <NitroDivider noTopPad sidePanel />
          <SummaryHeading title={category} result={HeaderPostFix} /> 
        </section>);

    return (
      <SidepanelSection footerDivider={footerDivider}>
        {header}
        <NitroDefinition data={summary} rowspacing={ExtraSpacingRows ? 20 : 4}/>
      </SidepanelSection>
    );
  }
}

SummaryTable.propTypes = {
  category: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  HeaderPostFix: PropTypes.string,
  ExtraSpacingRows: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  footerDivider: PropTypes.bool,
  formatting: PropTypes.bool
};

SummaryTable.defaultProps = {
  footerDivider: false,
  formatting: true
  
};


export default SummaryTable;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/SummaryTable.js